import {
    Accordion,
    AccordionButton,
    AccordionItem,
    AccordionPanel,
} from "@chakra-ui/react";
import { Checkbox } from "barte-design-system";
import { ReactNode } from "react";
import { UseFormSetValue, UseFormWatch } from "react-hook-form";

interface AccordionCheckboxProps {
    primaryLabel: ReactNode;
    secondaryLabel: ReactNode;
    primaryName: string;
    secondaryName: string;
    setValue: UseFormSetValue<any>;
    watch: UseFormWatch<any>;
    mt?: string;
}

export function AccordionCheckbox({
    primaryLabel,
    secondaryLabel,
    primaryName,
    secondaryName,
    setValue,
    watch,
    mt,
}: AccordionCheckboxProps) {
    const isOpen: boolean = watch(primaryName) ?? false;
    const secondaryChecked: boolean = watch(secondaryName) ?? false;

    function handlePrimaryChange(checked: boolean) {
        setValue(primaryName, checked, { shouldValidate: true, shouldDirty: true });
        if (!checked) {
            setValue(secondaryName, false, { shouldValidate: true, shouldDirty: true });
        }
    }

    function handleSecondaryChange(checked: boolean) {
        setValue(secondaryName, checked, { shouldValidate: true, shouldDirty: true });
    }

    return (
        <Accordion
            allowToggle
            index={isOpen ? 0 : -1}
            mt={mt ?? "12px"}
            mb="12px"
            p={isOpen ? "16px" : "0 16px"}
        >
            <AccordionItem border="none">
                <AccordionButton
                    display="flex"
                    borderTop="none"
                    p="0"
                    alignItems="flex-start"
                    textAlign="left"
                    gap="2"
                    _hover={{ backgroundColor: "none" }}
                >
                    <Checkbox
                        checked={isOpen}
                        onChange={handlePrimaryChange}
                        label={primaryLabel}
                    />
                </AccordionButton>
                <AccordionPanel px={0} py={2}>
                    <Checkbox
                        checked={secondaryChecked}
                        onChange={handleSecondaryChange}
                        label={secondaryLabel}
                    />
                </AccordionPanel>
            </AccordionItem>
        </Accordion>
    );
}
